module.exports = __webpack_public_path__ + "img/th_Type_2.1.5e771398.jpg";